"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-wrapper"
  }, [_c("el-card", {
    staticClass: "modern-card",
    attrs: {
      shadow: "never"
    }
  }, [_c("div", {
    staticClass: "form-header"
  }, [_c("h2", [_vm._v("Contact Details")]), _c("span", {
    staticClass: "form-sub"
  }, [_vm._v("Manage client information")])]), _c("el-form", {
    ref: "formData",
    staticClass: "modern-form",
    attrs: {
      model: _vm.formData,
      rules: _vm.rules,
      "label-position": "top"
    }
  }, [_c("div", {
    staticClass: "form-grid"
  }, [_c("el-form-item", {
    attrs: {
      label: "Enabled",
      prop: "enabled"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "enabled", $$v);
      },
      expression: "formData.enabled"
    }
  })], 1), _vm.formData.status === "Pending" ? _c("el-form-item", {
    attrs: {
      label: "Status",
      prop: "status"
    }
  }, [_c("el-select", {
    staticClass: "full",
    attrs: {
      placeholder: "Select status",
      filterable: ""
    },
    model: {
      value: _vm.formData.status,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "status", $$v);
      },
      expression: "formData.status"
    }
  }, _vm._l(_vm.userOptions, function (status) {
    return _c("el-option", {
      key: status.key,
      attrs: {
        label: status.label,
        value: status.key
      }
    });
  }), 1)], 1) : _vm._e(), _c("el-form-item", {
    attrs: {
      label: "Salutation"
    }
  }, [_c("el-select", {
    staticClass: "full",
    attrs: {
      placeholder: "Select",
      filterable: ""
    },
    model: {
      value: _vm.formData.salutation,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "salutation", $$v);
      },
      expression: "formData.salutation"
    }
  }, _vm._l(_vm.salutationType, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.value,
        value: item.key
      }
    });
  }), 1)], 1), _c("el-form-item", {
    attrs: {
      label: "First Name",
      prop: "firstName"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter first name",
      maxlength: "150",
      "show-word-limit": ""
    },
    model: {
      value: _vm.formData.firstName,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "firstName", $$v);
      },
      expression: "formData.firstName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Last Name",
      prop: "lastName"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter last name",
      maxlength: "150",
      "show-word-limit": ""
    },
    model: {
      value: _vm.formData.lastName,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "lastName", $$v);
      },
      expression: "formData.lastName"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Mobile Number",
      prop: "mobileNumber"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter mobile number",
      maxlength: "10",
      inputmode: "numeric"
    },
    on: {
      input: _vm.handleMobileInput,
      change: _vm.validateMobileNumber
    },
    model: {
      value: _vm.formData.mobileNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "mobileNumber", $$v);
      },
      expression: "formData.mobileNumber"
    }
  }, [_c("template", {
    slot: "prepend"
  }, [_vm._v(" +91 ")])], 2)], 1), _c("el-form-item", {
    attrs: {
      label: "Landline Number"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter landline"
    },
    model: {
      value: _vm.formData.landlineNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "landlineNumber", $$v);
      },
      expression: "formData.landlineNumber"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Email",
      prop: "emailAddress"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter email"
    },
    model: {
      value: _vm.formData.emailAddress,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "emailAddress", $$v);
      },
      expression: "formData.emailAddress"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Designation"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Sales Executive"
    },
    model: {
      value: _vm.formData.designation,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "designation", $$v);
      },
      expression: "formData.designation"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Department"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Department name"
    },
    model: {
      value: _vm.formData.department,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "department", $$v);
      },
      expression: "formData.department"
    }
  })], 1), _c("el-form-item", {
    staticClass: "form-item-modern",
    attrs: {
      label: "Communication Mode"
    }
  }, [_c("el-select", {
    staticClass: "full",
    attrs: {
      placeholder: "Select"
    },
    model: {
      value: _vm.formData.communicationPreference,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "communicationPreference", $$v);
      },
      expression: "formData.communicationPreference"
    }
  }, _vm._l(_vm.communicationType, function (item) {
    return _c("el-option", {
      key: item.key,
      attrs: {
        label: item.value,
        value: item.key
      }
    });
  }), 1)], 1)], 1), _c("el-form-item", {
    staticClass: "full-row",
    attrs: {
      label: "Address"
    }
  }, [_c("el-input", {
    attrs: {
      type: "textarea",
      autosize: {
        minRows: 3,
        maxRows: 5
      },
      maxlength: "200",
      placeholder: "Enter full address"
    },
    model: {
      value: _vm.formData.address,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "address", $$v);
      },
      expression: "formData.address"
    }
  })], 1), _c("div", {
    staticClass: "form-grid"
  }, [_c("el-form-item", {
    attrs: {
      label: "GST"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter GST"
    },
    on: {
      input: _vm.handleGSTChange
    },
    model: {
      value: _vm.formData.gstNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "gstNumber", $$v);
      },
      expression: "formData.gstNumber"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "PAN",
      prop: "panNumber"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "Enter PAN (e.g. ABCDE1234F)",
      maxlength: "10"
    },
    on: {
      input: function ($event) {
        _vm.formData.panNumber = ($event || "").toUpperCase();
      }
    },
    model: {
      value: _vm.formData.panNumber,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "panNumber", $$v);
      },
      expression: "formData.panNumber"
    }
  })], 1)], 1), _c("el-form-item", {
    attrs: {
      label: "GST Attachment"
    }
  }, [_c("el-upload", {
    staticClass: "upload-modern",
    attrs: {
      action: "#",
      "auto-upload": false,
      limit: 1,
      "list-type": "picture-card",
      "file-list": _vm.gstFileList,
      "on-change": _vm.handleGSTFileChange,
      "on-remove": _vm.handleGSTRemove,
      "on-preview": _vm.handlePreview
    }
  }, [_c("i", {
    staticClass: "el-icon-plus"
  })])], 1), _c("el-dialog", {
    attrs: {
      visible: _vm.previewVisible,
      width: "500px"
    },
    on: {
      "update:visible": function ($event) {
        _vm.previewVisible = $event;
      }
    }
  }, [_c("img", {
    attrs: {
      width: "100%",
      src: _vm.previewUrl
    }
  })]), _vm.isDuplicateMobile ? _c("el-form-item", {
    attrs: {
      label: "Transfer Contact"
    }
  }, [_c("el-switch", {
    attrs: {
      "inactive-text": "No",
      "active-text": "Yes",
      disabled: _vm.isSameClient
    },
    model: {
      value: _vm.allowContactTransfer,
      callback: function ($$v) {
        _vm.allowContactTransfer = $$v;
      },
      expression: "allowContactTransfer"
    }
  }), _c("el-alert", {
    staticClass: "mt10",
    attrs: {
      title: _vm.mobileAlert,
      type: "warning",
      closable: false
    }
  })], 1) : _vm._e(), _c("div", {
    staticClass: "form-actions"
  }, [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "save-btn",
    attrs: {
      disabled: _vm.allowSubmit(),
      type: "success",
      size: "medium"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" Save Contact ")])], 1)], 1)], 1)], 1);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;